import { render, staticRenderFns } from "./CropRotationDisplay.vue?vue&type=template&id=0c8cd2a8&scoped=true&lang=html&"
import script from "./CropRotationDisplay.vue?vue&type=script&lang=js&"
export * from "./CropRotationDisplay.vue?vue&type=script&lang=js&"
import style0 from "./CropRotationDisplay.vue?vue&type=style&index=0&id=0c8cd2a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8cd2a8",
  null
  
)

export default component.exports